// <- TaskManagment.js
import React, { useState, Fragment,useEffect  } from "react";
import { Button, ListGroup, ListGroupItem } from "reactstrap";
import TableWithSortPagtn from "../../common/TableWithSortPagtnWithTot";
import DropDownActions from "../../common/DropDownActions";
import { Table, Checkbox } from "semantic-ui-react";
import moment from 'moment';
const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
let sumhours=0;
let sumbillable=0;
let maxwidth="80vw";
const ListYearlyStatusView = React.memo(
  ({
    handleAddEditTaskForm,
    handleSelectedTask,
    handleOpenCalendar,
    handleDelTask,
    empTask,
    taskProjectInfo,
    handleToggleAllTaskCalendar,
    getAllTaskOfEmployee,
    handleUnlockRequestForm
  }) => {
   
    const [trow, setTrow] = useState([]);
    const [activeTask, setActiveTask] = useState(0);
   
    const handleOnclickSelectedTask = React.useCallback(
      (task, i) => {
        setActiveTask(i);
        handleSelectedTask(task);
      },
      [handleSelectedTask]
    );

   

    const DelTask=React.useCallback(
      (delId)=>{
      handleDelTask(delId);
    },[empTask]);

    const groupedData = empTask.reduce((acc, item) => {
      if (!acc[item.employeeID]) {
        acc[item.employeeID] = {
          employeeName: item.employeeName,
          department: item.departmentName,
          leaveTypes:item.leaveTypes,
          leaves: {},
        };
      }
      acc[item.employeeID].leaves[item.monthName] = {
        leaveCount: item.leaveCount,
        leaveTypes: item.leaveTypes,
      };
      return acc;
    }, {});
  
    const months = [
      "January", "February", "March", "April", "May", "June", 
      "July", "August", "September", "October", "November", "December"
    ];
    const chunkArray = (arr, size) => {
      return Array.from({ length: Math.ceil(arr.length / size) }, (_, index) =>
        arr.slice(index * size, index * size + size)
      );
    };
    const chunkedMonths = chunkArray(months, 6);
    return (
      
      <Fragment>
        <div className="fixed-header">
          <div>
         
            &nbsp;
            <h5 className="mb-3">Yearly Status</h5>
            <div className="d-inline float-right ">
           
            </div>
          </div>
        </div>
        <div style={{ maxWidth:"100%", overflowX: "hidden" }}>
      {Object.entries(groupedData).map(([employeeId, data]) => (
        <div key={employeeId} className="mb-4 border p-3 rounded shadow-sm">
          <h6 className="mb-2">Employee: {data.employeeName} (ID: {data.employeeCode})</h6>
          <p><strong>Department:</strong> {data.department}</p>

          {chunkedMonths.map((monthChunk, index) => (
            <Table key={index} bordered responsive className="mb-3">
              <thead className="bg-light">
                <tr>
                  {monthChunk.map((month) => (
                    <th key={month}>{month}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {monthChunk.map((month) => (
                    <td key={month}>
                      {data.leaves[month] ? (
                        <>
                          <strong>Leaves Taken:</strong> {data.leaves[month].leaveCount} <br />
                        </>
                      ) : (
                        "No Leave"
                      )}
                    </td>
                  ))}
                </tr>
                
              </tbody>
              
            </Table>
          
          ))}
          <div><tr>{data.leaveTypes}</tr></div>
        </div>
      ))}
    </div>
     
      </Fragment>
    );
  }
);

export default ListYearlyStatusView;
